export default __webpack_public_path__ + "static/media/appscreenrecording.75cf7845.mp4";